import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import PlanItemsView from "@/components/PlanItemsView";

/**
 * Read-only preview of a plan/template with days.
 * plan: { name, description?, days[] } (falls back to flat items if legacy)
 * exercises: exercise library
 */
export default function PreviewPlanModal({ open, onOpenChange, plan, exercises }) {
  const days = plan?.days || (plan?.items ? [{ id: "legacy", name: "Giorno 1", items: plan.items }] : []);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="preview-plan-modal"
        className="bg-[#120B19] border-white/10 text-white rounded-none max-w-3xl w-[95vw] max-h-[90vh] overflow-y-auto p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle className="font-heading uppercase tracking-tight" data-testid="preview-plan-title">
            {plan?.name || "Scheda"}
          </DialogTitle>
        </DialogHeader>
        {plan?.description && (
          <p className="text-sm text-white/70 mb-3" data-testid="preview-plan-desc">{plan.description}</p>
        )}
        {days.length === 0 && <div className="text-white/40 text-sm">Nessun giorno.</div>}
        <div className="space-y-4">
          {days.map((d, i) => (
            <div key={d.id || i} data-testid={`preview-day-${i}`} className="border border-white/10 p-3">
              <div className="label-caps mb-2">{d.name || `Giorno ${i + 1}`} · {(d.items || []).length} eserciz{(d.items || []).length === 1 ? "io" : "i"}</div>
              <PlanItemsView items={d.items || []} exercises={exercises} testidPrefix={`preview-day-${i}-item`} />
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
